module.exports = __webpack_public_path__ + "fonts/DMSans-Italic.b8926729.ttf";